module.exports = __webpack_public_path__ + "static/img/white-1.a462eb3c.png";